import {render} from "react-dom";
import buildStore from './data/store';
import HealthCheck from "./components/HealthCheck";
import autoCleanCache from './auto/autoCleanCache';
import {publicFunctions} from './data/public-functions';
import {initialize, OctaviusRocksPublic, PublicAPI, ServerConfigWithClientSecret} from '@octavius-rocks/api'
import MetaBox from "./components/MetaBox";
import {autoWordPress} from './auto/autoWordPress'
import {autoWebsocket} from './auto/autoWebsocket';
import StatisticsRocksWidget from "./components/StatisticsRocksWidget";
import ProviderWrapper from "./context/ProviderWrapper";
import {waitForGet} from "./utils/api";
import LiveUserRocks from "./components/LiveUserRocks/LiveUserRocks";
import LiveUserRocksConfig from "./components/LiveUserRocks/LiveUserRocksConfig";
import {getClusterFunction} from "./hook/useBreakpoints";
import App from "./components/App";


declare global {
    interface Window {
        WP_OctaviusRocks_Admin: {
            config: ServerConfigWithClientSecret
            api: PublicAPI
            store: any
            data: any
            breakpointClusters: any
        };
    }
}

((oc) => {

    const {
        config
    } = oc;

    const api = oc.api = OctaviusRocksPublic({
        clientSecret: config.clientSecret,
        ...config,
    })

    const tryToRender = (component, element, ifSuccessFn?: () => void) => {
        try {
            render(component, element);
            if (typeof ifSuccessFn === "function") ifSuccessFn();
        } catch (e) {
            console.error(e);
        }
    }

    document.addEventListener('DOMContentLoaded', async () => {

        // DOM root elements
        const realtimeElement = document.getElementById("octavius-rocks-realtime-widget")
        const realtimeConfigElement = document.getElementById("octavius-rocks-realtime-config")
        const pageviewElement = document.getElementById("oc-widget-pageviews")
        const dashboard = document.getElementById("octavius-rocks-dashboard")
        const healthCheck = document.getElementById("octavius-health-api-connection")
        const metaBoxElement = document.getElementById("octavius-rocks-meta-box")

        if (
            realtimeElement || realtimeConfigElement
            ||
            pageviewElement
            ||
            dashboard
            ||
            healthCheck
        ) {
            await initialize(config);
        }

        //---------------------------------------------
        // redux store
        //---------------------------------------------
        const store = oc.store = buildStore();
        oc.data = publicFunctions(store);
        autoCleanCache(store);

        //---------------------------------------------
        // Query widget
        //---------------------------------------------
        if (pageviewElement) {
            tryToRender(
                <ProviderWrapper store={store}>
                    <StatisticsRocksWidget/>
                </ProviderWrapper>,
                pageviewElement,
                () => {
                    autoWordPress(store)
                }
            );
        }

        //---------------------------------------------
        // Realtime widget
        //---------------------------------------------
        if (realtimeElement) {
            // render live data widget
            tryToRender(
                <ProviderWrapper store={store}>
                    <LiveUserRocks breakpointsCluster={getClusterFunction()}/>
                </ProviderWrapper>,
                realtimeElement,
                () => {
                    waitForGet(api, (get) => {
                        autoWebsocket(store, get);
                    });
                    autoWordPress(store)
                }
            );
        } else if (realtimeConfigElement) {
            // render configuration view of widget
            tryToRender(
                <ProviderWrapper store={store}>
                    <LiveUserRocksConfig config={oc.breakpointClusters}/>
                </ProviderWrapper>,
                realtimeConfigElement
            );
        }

        //---------------------------------------------
        // dashboard pages
        //---------------------------------------------
        if (dashboard) {
            tryToRender(
                <ProviderWrapper store={store}>
                    <App />
                </ProviderWrapper>,
                dashboard,
                () => {
                    autoWordPress(store)
                }
            )
        }

        //---------------------------------------------
        // meta box
        //---------------------------------------------
        if (metaBoxElement) {
            tryToRender(
                <MetaBox/>,
                metaBoxElement.querySelector(".inside")
            )
        }

        //---------------------------------------------
        // Octavius pages
        //---------------------------------------------
        if (healthCheck) {
            tryToRender(
                <HealthCheck api={api}/>,
                healthCheck,
            )
        }
    });


})(window.WP_OctaviusRocks_Admin);
